/*
 * Copyright 2026 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Routes, Route } from 'react-router-dom';
import { Content } from '@backstage/core-components';
import { OngoingTaskBody } from '../../components/OngoingTask';
import { ListTaskPageContent } from '../../components/ListTasksPage';

/**
 * Sub-page for the tasks tab. Renders the task list at the index route
 * and the ongoing task detail at the parameterized route.
 *
 * @internal
 */
export function TasksSubPage() {
  return (
    <Routes>
      <Route
        index
        element={
          <Content>
            <ListTaskPageContent />
          </Content>
        }
      />
      <Route path=":taskId" element={<OngoingTaskBody />} />
    </Routes>
  );
}
